import styled from 'styled-components'

export const Container = styled.div`
  font-size: var(--font-size-300);
  font-style: normal;
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-300); /* 142.857% */
  letter-spacing: var(--font-letter-spacing-loose);
  color: var(--text-secondary);
`

export const Label = styled.div`
  display: flex;
  gap: var(--space-150);
  align-items: center;
`
